/**
 * version: 1.0.0
 * release date: 20xx.xx.xx
 * author: John Bandy, john@concatsys.com
 * company: Concat Systems, Inc.
 *
 * copyright 20xx Concat Systems, Inc.
 *
 * version history:
 *   • 1.0.0 : initial release
 */

// core functionality
//------------------------------------------------------------------------------
const _Levels = 
  {
    NONE    : 0,
    ERROR   : 1,
    WARN    : 2,
    INFO    : 3,
    DEBUG   : 4
  };
//------------------------------------------------------------------------------
let _level = _Levels.ERROR;
let _counter = 0;
//------------------------------------------------------------------------------
const _log = ( () => 
  {
    let log = console.log;

    let pad = ( n, s=2 ) => {
      let a = String( n );
      while( a.length < s ) { a = "0" + a; }
      return( a );
    };

    let parts = ( d ) => ({ 
        h  : pad( d.getHours(), 2 ),
        m  : pad( d.getMinutes(), 2 ),
        s  : pad( d.getSeconds(), 2 ),
        ms : pad( d.getMilliseconds(), 3 )
    });

    return function( id, ...args ) {
      let { h, m, s, ms } = parts( new Date() );
      args.unshift( `#${pad(_counter++,3)} [${h}:${m}:${s}.${ms}] ${id} ::` );
      log.apply( console, args );
    };
  })()
//------------------------------------------------------------------------------
const _Level = function() 
  {
    if( arguments.length === 0 )
      return( _level );
    _level = _normalize( arguments[0] );
  }
//------------------------------------------------------------------------------
const _Out = function( level, ...args ) 
  {      
    _normalize( level ) <= _level
      && _log.apply( this, args );
  }

// helper/convenience funcs
//------------------------------------------------------------------------------
const _normalize = ( lvl ) => 
  {
    let v = ( typeof lvl === "string" )
          ? _Levels[ lvl.toUpperCase() ]
          : ( typeof lvl === "number" ) && _Levels.NONE < lvl && lvl <= _Levels.DEBUG
          ? lvl
          : undefined;
    return( v || _Levels.NONE );
  }
const _Error = function() { _Out.apply( this, [ _Levels.ERROR ].concat( Array.prototype.slice.call( arguments ) ) ); };
const _Warn  = function() { _Out.apply( this, [ _Levels.WARN ].concat( Array.prototype.slice.call( arguments ) ) ); };
const _Info  = function() { _Out.apply( this, [ _Levels.INFO ].concat( Array.prototype.slice.call( arguments ) ) ); };
const _Debug = function() { _Out.apply( this, [ _Levels.DEBUG ].concat( Array.prototype.slice.call( arguments ) ) ); };

// public access
//------------------------------------------------------------------------------
const Log = {
  _      : _Out,
  out    : _Out,
  error  : _Error,
  warn   : _Warn,
  info   : _Info,
  debug  : _Debug,
  level  : _Level, 
  Levels : _Levels  
}

// wrapping up...
//------------------------------------------------------------------------------

// 
window.concat = window.concat || {};
window.concat.utils = window.concat.utils || {};
window.concat.utils.Log = Log;


// end module
export { Log };
